import { memo, useCallback } from 'react';
import { Pressable } from 'react-native';
import { CategoryProps } from './Category.types';
import { State, useSelector } from '@betty/toolkit/state';
import { Box, Icon, Text } from '@betty/moonlight';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { selectCategory } from '../../../state';
import {
  DEFAULT_CATEGORY_STYLE_CONFIG,
  JACKPOT_CATEGORY_STYLE_CONFIG,
} from '../Categories.content';
import Games from '../../Games/Games';
import { CategoryGame } from '../../../state/shared/categories.types';

function Category({ categoryId, ...rest }: CategoryProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const category = useSelector((state: State) =>
    selectCategory(state, categoryId),
  );

  const onCategoryPress = useCallback(() => {
    navigation.navigate('CategoryDetailsScreen', { id: categoryId });
  }, [categoryId, navigation]);

  if (!category || !category.games.length) {
    return null;
  }

  const reducedGameIds = category.games.reduce(
    (acc: CategoryGame['id'][], game, index) => {
      if (index < 150) {
        acc.push(game.id);
      }
      return acc;
    },
    [],
  );
  const isJackpot = category.theme.name === 'Jackpot';

  return (
    <Box
      gap="space-200"
      {...(isJackpot && JACKPOT_CATEGORY_STYLE_CONFIG.box)}
      {...rest}
    >
      <Pressable onPress={onCategoryPress}>
        <Box
          gap="space-100"
          alignItems="center"
          flexDirection="row"
          paddingHorizontal="space-400"
        >
          <Text
            variant="h6"
            {...(isJackpot
              ? JACKPOT_CATEGORY_STYLE_CONFIG.text
              : DEFAULT_CATEGORY_STYLE_CONFIG)}
          >
            {category.title}
          </Text>
          <Icon gradient="accentBackground" name="arrowForwardIosOutlined" />
        </Box>
      </Pressable>
      <Box flex={1}>
        <Games ids={reducedGameIds} imageType={category.imageType.name} />
      </Box>
    </Box>
  );
}

export default memo(Category);
